import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "同类盘点", to: "/pandian" },
  { label: "对比分析", to: "/duibi" },
  { label: "系列事件", to: "/shijian" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // 系列事件无独立落地页，导航跳转到首页系列区块
  const resolvedTo = (to: string) => {
    if (to === "/shijian") return `${"/"}#series`;
    return to;
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled || open ? "bg-background-50/95 shadow-sm border-b border-background-200" : "bg-background-50/0"
      }`}
      onScrollCapture={() => setScrolled(window.scrollY > 20)}
    >
      <div className="mx-auto flex h-16 max-w-container items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="热瓜雷达 首页">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-radar-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl text-primary-600">热瓜雷达</span>
            <span className="text-[10px] tracking-widest text-foreground-500">全网热瓜观测站</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) =>
            item.to === "/shijian" ? (
              <a
                key={item.to}
                href="#series"
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={resolvedTo(item.to)}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-medium transition ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ),
          )}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/faq"
            className="hidden items-center gap-1 whitespace-nowrap rounded-full border border-primary-300 px-4 py-2 text-sm text-primary-700 transition hover:bg-primary-100 sm:flex"
          >
            <i className="ri-question-line"></i>
            常见问题
          </Link>
          <Link
            to="/about"
            className="hidden whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm text-background-50 transition hover:bg-accent-600 md:inline-flex"
          >
            联系我们
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 transition hover:bg-background-100 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.to}
                href={resolvedTo(item.to)}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-primary-100"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-2 flex gap-2 border-t border-background-200 pt-3">
              <Link to="/faq" onClick={() => setOpen(false)} className="flex-1 rounded-full border border-primary-300 px-3 py-2 text-center text-sm text-primary-700">
                常见问题
              </Link>
              <Link to="/about" onClick={() => setOpen(false)} className="flex-1 rounded-full bg-accent-500 px-3 py-2 text-center text-sm text-background-50">
                联系我们
              </Link>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}